import {
  IntegrationAccountRemovedPayload,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import type { IEventEmitter } from '../EventEmitter';
import { WebSocketEventType } from '../WebSocketContext';

export function createIntegrationAccountMessageHandler(
  eventEmitter: IEventEmitter,
) {
  return (action: WebSocketAction, item: IntegrationAccountRemovedPayload) => {
    try {
      if (action !== WebSocketAction.REMOVE) {
        log.warn(
          '[IntegrationAccountHandler] Unknown action for IntegrationAccount:',
          action,
        );
        return;
      }

      log.debug(
        `[IntegrationAccountHandler] REMOVE IntegrationAccount ${item.platform}`,
      );
      eventEmitter.emit(
        WebSocketEntityType.IntegrationAccount,
        WebSocketEventType.REMOVE,
        item,
      );
    } catch (error) {
      log.error('[IntegrationAccountHandler] Handler failed:', error);
    }
  };
}
